import React from 'react'
import { Provider } from 'react-redux'

import './App.css'

import Navigation from './navigation'
import { FirebaseProvider } from './firebaseContext'
import { ProvideAuth } from './authContext'
import store from './redux/store'
import { ReduxProvider } from './redux'

function App() {
  return (
    <div className="app">
      <FirebaseProvider>
        <ProvideAuth>
          <Provider store={store}>
            <ReduxProvider>
              <Navigation />
            </ReduxProvider>
          </Provider>
        </ProvideAuth>
      </FirebaseProvider>
    </div>
  )
}

export default App
